import React from 'react';
import styled from 'styled-components';
import ServicePage from './ServicePage';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import WebImage from "../assets/web.webp"

const SectionTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
  margin: ${props => props.margin || '0 0 20px 0'};
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    justify-content: space-around;
  }
  
  @media (max-width: 576px) {
    justify-content: center;
  }
`;

const WebsiteCard = styled.div`
  flex: 0 0 43%;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  
  @media (max-width: 968px) {
    flex: 0 0 90%;
  }
  
  @media (max-width: 576px) {
    flex: 0 0 85%;
  }
  
  h4 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #6772e5;
  }
  
  p {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
  }
`;

const TechContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  
  @media (max-width: 576px) {
    gap: 15px;
  }
`;

const TechTag = styled.div`
  padding: 15px 25px;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: 576px) {
    padding: 12px 20px;
    font-size: 13px;
  }
`;

const WebsiteDevelopmentPage = () => {
  const features = [
    'Responsive design for all devices and screen sizes',
    'Custom website development tailored to your brand',
    'Content management systems (WordPress, Drupal, etc.)',
    'E-commerce solutions with secure payment integration',
    'SEO optimization for better search engine visibility',
    'Website maintenance and regular updates'
  ];

  const additionalContent = (
    <div>
      <SectionTitle>
        Our Website Development Services
      </SectionTitle>
      <CardContainer>
        <WebsiteCard>
          <h4>Corporate Websites</h4>
          <p>
            Professional websites that showcase your brand identity, services, and establish credibility with your audience.
          </p>
        </WebsiteCard>
        <WebsiteCard>
          <h4>E-Commerce Platforms</h4>
          <p>
            Robust online stores with secure payment gateways, inventory management, and seamless shopping experiences.
          </p>
        </WebsiteCard>
        <WebsiteCard>
          <h4>Web Applications</h4>
          <p>
            Custom web applications that automate business processes and provide interactive user experiences.
          </p>
        </WebsiteCard>
        <WebsiteCard>
          <h4>Responsive Design</h4>
          <p>
            We create websites that look and function perfectly on all devices, from desktops to smartphones. Our mobile-first approach ensures optimal user experience regardless of screen size.
          </p>
        </WebsiteCard>
      </CardContainer>
      
      <SectionTitle margin="50px 0 20px">
        Technologies We Use
      </SectionTitle>
      <TechContainer>
        <TechTag>HTML5</TechTag>
        <TechTag>CSS3</TechTag>
        <TechTag>JavaScript</TechTag>
        <TechTag>React</TechTag>
        <TechTag>WordPress</TechTag>
        <TechTag>PHP</TechTag>
        <TechTag>Node.js</TechTag>
      </TechContainer>
    </div>
  );

  return (
    <ServicePage
      icon={faGlobe}
      title="Website Development"
      subtitle="Custom websites designed to showcase your brand, engage visitors, and drive conversions."
      description={["At Zenitech Solutions, our Website Development services are designed to transform your online presence through visually stunning, high-performing websites that align with your business objectives. Whether you're launching a sleek corporate site, a robust e-commerce platform, or a fully customized web application, we deliver digital experiences that are both beautiful and powerful.",

        "Our expert developers and designers work collaboratively to create responsive, user-friendly, and SEO-optimized websites that captivate visitors and convert them into customers. We prioritize clean code, seamless navigation, and scalable architecture — ensuring your website is not only fast and secure but also future-ready.",
        
        "From concept to launch, we focus on building websites that reflect your brand, engage your audience, and drive measurable results. With Zenitech Solutions, your website becomes a strategic asset that fuels growth and enhances your digital success."]}
      features={features}
      imagePath={WebImage}
      additionalContent={additionalContent}
      featuresDesciption="We deliver custom website development solutions designed to match your unique business goals. Our experienced team combines creative design with powerful functionality, ensuring every website we build is responsive, user-friendly, and crafted with precision and attention to detail."
      metaTitle="Website Development Services"
      metaDescription="Our Website Development services provide comprehensive solutions for your website needs. From concept to launch, we deliver high-quality, user-centric websites that align with your goals."
    />
  );
};

export default WebsiteDevelopmentPage;